import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { observer } from 'mobx-react'
import styles from './index.module.scss'

type Props = {
  rate: number
}

export const ProfileCompletionRateBar: FC<Props> = observer(({ rate }) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <>
      <div className={styles.content}>
        <div className={styles.label}>
          <div>{t('プロフィール入力率')}</div>
          <div>{`${rate || 0}%`}</div>
        </div>
        <div className={styles.bar}>
          <div className={styles.filler} style={{ width: `${rate}%` }} />
        </div>
      </div>
    </>
  )
})
